import { CurrentSubscription } from "shared/models/companies/company";

export class UserAddonDTO {
    billedAdditionalUsers: number = 0;
    effectiveAdditionalUsers: number = 0;
    nextCycleAdditionalUsers: number = 0;
    hasPendingSchedule: boolean = false;
    scheduledEffectiveAt: string | null = null;
    addonSlotsScheduledToRemove: number = 0;

    constructor(data: Partial<UserAddonDTO> = {}) {
        Object.assign(this, data);
    }
}

export class WarehouseAddonDTO {
    billedAdditionalWarehouses: number = 0;
    effectiveAdditionalWarehouses: number = 0;
    nextCycleAdditionalWarehouses: number = 0;
    hasPendingSchedule: boolean = false;
    scheduledEffectiveAt: string | null = null;
    addonSlotsScheduledToRemove: number = 0;

    constructor(data: Partial<WarehouseAddonDTO> = {}) {
        Object.assign(this, data);
    }
}

export class ServiceTruckAddonDTO {
    billedQuantity: number = 0;
    effectiveQuantity: number = 0;
    nextCycleQuantity: number = 0;
    hasPendingSchedule: boolean = false;
    scheduledEffectiveAt: string | null = null;
    addonSlotsScheduledToRemove: number = 0;

    constructor(data: Partial<ServiceTruckAddonDTO> = {}) {
        Object.assign(this, data);
    }
}

export class MySubscriptionCurrentSubscriptionDTO extends CurrentSubscription {
    userAddon: UserAddonDTO = new UserAddonDTO();
    warehouseAddon: WarehouseAddonDTO = new WarehouseAddonDTO();
    serviceTruckAddon: ServiceTruckAddonDTO = new ServiceTruckAddonDTO();

    constructor(data: Partial<MySubscriptionCurrentSubscriptionDTO> = {}) {
        super(data);
        this.userAddon = new UserAddonDTO(data.userAddon);
        this.warehouseAddon = new WarehouseAddonDTO(data.warehouseAddon);
        this.serviceTruckAddon = new ServiceTruckAddonDTO(data.serviceTruckAddon);
    }
}

export class SubscriptionLimitsDTO {
    totalCurrentUserLimit: number = 0;
    totalCurrentWarehouseLimit: number = 0;
    totalCurrentServiceTruckLimit: number = 0;

    constructor(data: Partial<SubscriptionLimitsDTO> = {}) {
        Object.assign(this, data);
    }
}

export class SubscriptionCurrentUsageDTO {
    currentlyUsers: number = 0;
    currentlyWarehouses: number = 0;
    currentlyServiceTrucks: number = 0;

    constructor(data: Partial<SubscriptionCurrentUsageDTO> = {}) {
        Object.assign(this, data);
    }
}

export class SubscriptionExpiredCountsDTO {
    userExpired: number = 0;
    warehouseExpired: number = 0;
    serviceTruckExpired: number = 0;

    constructor(data: Partial<SubscriptionExpiredCountsDTO> = {}) {
        Object.assign(this, data);
    }
}

export class SubscriptionScheduledExpiredCountsDTO {
    userScheduledExpired: number = 0;
    warehouseScheduledExpired: number = 0;
    serviceTruckScheduledExpired: number = 0;
    userScheduledExpiredExcludingWarehouseUsers: number = 0;

    constructor(data: Partial<SubscriptionScheduledExpiredCountsDTO> = {}) {
        Object.assign(this, data);
    }
}

export class MySubscriptionResponseDTO{
    currentWarehouseCount: number = 0;
    currentUserCount: number = 0;
    currentServiceTruckCount: number = 0;
    additionalUsersAddonCount: number = 0;
    additionalWarehouseAddonCount: number = 0;
    serviceTruckAddonCount: number = 0;
    nextCycleAdditionalUsers: number = 0;
    nextCycleAdditionalWarehouses: number = 0;
    nextCycleServiceTruckAddonCount: number = 0;
    companyAddonScheduledEffectiveAt: string | null = null;
    serviceTruckAddonScheduledEffectiveAt: string | null = null;
    paidUsers: number = 0;
    freeUsers: number = 0;
    subscriptions: CurrentSubscription[] = [];
    subscription: MySubscriptionCurrentSubscriptionDTO = new MySubscriptionCurrentSubscriptionDTO();
    limits: SubscriptionLimitsDTO = new SubscriptionLimitsDTO();
    currentUsage: SubscriptionCurrentUsageDTO = new SubscriptionCurrentUsageDTO();
    expired: SubscriptionExpiredCountsDTO = new SubscriptionExpiredCountsDTO();
    scheduledExpired: SubscriptionScheduledExpiredCountsDTO = new SubscriptionScheduledExpiredCountsDTO();

    constructor(data: Partial<MySubscriptionResponseDTO> = {}){
        Object.assign(this, data);
        if(data.subscriptions){
            this.subscriptions = data.subscriptions.map(i => new CurrentSubscription(i))
        }
        if(data.subscription){
            this.subscription = new MySubscriptionCurrentSubscriptionDTO(data.subscription);
        }
        this.limits = new SubscriptionLimitsDTO(data.limits);
        this.currentUsage = new SubscriptionCurrentUsageDTO(data.currentUsage);
        this.expired = new SubscriptionExpiredCountsDTO(data.expired);
        this.scheduledExpired = new SubscriptionScheduledExpiredCountsDTO(data.scheduledExpired);
    }
}



